import { Employee, Patient } from '@ffd/api-client';

export interface BaseParticipantListItem {
  type: ParticipantListItemType;
}

export enum ParticipantListItemType {
  GroupDivider,
  Participant,
}

export type ParticipantListItem = Participant | ParticipantGroup;

export type Participant = Partial<Employee | Patient> & BaseParticipantListItem;

export interface ParticipantGroup extends BaseParticipantListItem {
  title: string;
  divide?: boolean;
  type: ParticipantListItemType.GroupDivider;
}

export type ParticipantsList = ParticipantListItem[];
